<template>
  <div class="Box">
    <div class="peopleInfo">
      <div class="Infohead">
        <img :src="UserInfo.headimgurl" alt />
      </div>
      <div class="InfoName">{{UserInfo.nickname}}</div>
    </div>
    <router-link to="/Mycoupon">
      <div class="MyList Mycoupon">
        <div>优惠卷</div>
      </div>
    </router-link>
    <router-link to="/MyAttention">
      <div class="MyList MyAttention">
        <div>关注的店</div>
      </div>
    </router-link>
    <router-link to="/MyQuestion">
      <div class="MyList MyQuestion">
        <div>常见问题</div>
      </div>
    </router-link>
    <router-link to="/Feedback">
      <div class="MyList Feedback">
        <div>问题反馈</div>
      </div>
    </router-link>
    <a :href="ZChttp" target="_blank">
       <div class="MyList ZCshop">
        <div>我要合作</div>
      </div>
    </a>
    <Nav tabindex="3"></Nav>
  </div>
</template>

<script>
import Nav from "../components/Nav";
export default {
  name: "",
  data() {
    return {
      ZChttp:this.$store.state.ZChttp,
      UserInfo: this.$store.state.UserInfo
    };
  },
  components: {
    Nav
  },
  created() {},
  mounted() {
    var openid = localStorage.getItem("ZQopenid");
    var UserInfo = localStorage.getItem("ZQUserInfo")
      ? JSON.parse(localStorage.getItem("ZQUserInfo"))
      : "";
    var location = JSON.parse(localStorage.getItem("ZQlocation"));
    this.$store.commit("location", location);
    this.$store.commit("UserInfo", {
      UserInfo: UserInfo
    });
     this.$store.commit("UserSelf", JSON.parse(localStorage.getItem("ZQUserSelf")));
    this.UserInfo = UserInfo;
    this.openid = UserInfo.openid;
  },
  methods: {}
};
</script>
<style lang='scss' scoped>
.Box {
  width: 100%;
  background-color: white;
  background-image: url(../assets/MyBack.png);
  background-repeat: no-repeat;
  background-size: 100% 2.76rem;
  padding-top: 1.6rem;
  padding-bottom: 1.2rem;
}
.peopleInfo {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.Infohead {
  width: 1.74rem;
  height: 1.74rem;
  border-radius: 100%;
  overflow: hidden;
  border: 4px solid #f39a65;
}
.Infohead img {
  width: 100%;
  height: 100%;
}
.InfoName {
  font-size: 0.29rem;
  color: #636363;
  line-height: 0.78rem;
  margin-bottom: 0.46rem;
}
.MyList {
  width: 6.7rem;
  height: 1.5rem;
  padding-left: 0.44rem;
  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.1);
  line-height: 1.5rem;
  font-size: 0.29rem;
  color: #636363;
  margin: 0 auto;
  margin-bottom: 0.3rem;
  background-position: top right;
  background-repeat: no-repeat;
  background-size: 3.2rem 1.5rem;
}
.Mycoupon {
  background-image: url(../assets/MyList01.jpg);
}
.MyAttention {
  background-image: url(../assets/MyList02.jpg);
}
.MyQuestion {
  background-image: url(../assets/MyList03.jpg);
}
.Feedback {
  background-image: url(../assets/MyList04.jpg);
}
.ZCshop{
  background-image: url(../assets/MyList05.jpeg);
}
</style>
